<template src="./Country.html"></template>

<script>
import analyticsTopMenu from "@/components/analytics/components/topMenu"
import Pagination from "@/components/components/pagination"
import Chart from '@/components/brand/dynamics/components/Chart';
import {createNamespacedHelpers} from 'vuex'
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"

const {mapGetters, mapActions} = createNamespacedHelpers('analytics/salesAnalyticsCountry')

export default {
  name: "SalesAnalyticsCountry",
  components: {
    analyticsTopMenu,
    Pagination,
    Chart,
    SelfDateRangePicker
  },
  data() {
    return {
      showOverlay: false,
      currentPage: 1,
      perPage: 10,
      fieldsList: [
        {
          key: 'countryName',
          label: 'Страна',
          sortable: true
        },
        {
          key: 'request',
          label: 'Запросы',
          sortable: true
        },
        {
          key: 'requisition',
          label: 'КП',
          sortable: true
        },
        {
          key: 'orderCount',
          label: 'Заказы',
          sortable: true
        },
        {
          key: 'averageCheck',
          label: 'Средний чек',
          sortable: true
        },
        {
          key: 'conversion',
          label: 'Конверсия',
          sortable: true
        },
      ],
      // chartName: '',
      sortBy: 'request',
      sortDesc: true,
      // activeQueryId: null,
      chartCountry: '',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
      getRange: null,
      groupOptions: [
        {
          text: 'Месяц',
          value: 'month',
        },
        {
          text: 'Неделя',
          value: 'week',
        },
        {
          text: 'День',
          value: 'day',
        },
      ],
      currentGroup: 'month',
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'GET_HISTORY',
    ]),
    getChartDat: function () {
      if (this.FROM != null && this.TO != null && this.CURRENT_COUNTRY_ID != null) {
        this.GET_HISTORY({th: this});
      }
    },
    selectCountry: function (countryId, countryName) {
      this.chartCountry = countryName
      this.$store.commit('analytics/salesAnalyticsCountry/CURRENT_COUNTRY_ID', countryId);
      this.getChartDat()
    },
    updateRangePicker: function (val) {
      this.$store.commit('analytics/salesAnalyticsCountry/FROM', val.from);
      this.$store.commit('analytics/salesAnalyticsCountry/TO', val.to);
      this.getChartDat()
      this.GET_DATA({th: this});
    },
  },
  computed: {
    ...mapGetters([
      'COUNTRY_DATA',
      'HISTORY_DATA1',
      'HISTORY_DATA2',
      'HISTORY_DATA3',
      'CURRENT_COUNTRY_ID',
      'FROM',
      'TO',
      'CURRENT_GROUP',
    ]),
    isDateSelected: function () {
      return this.FROM != null && this.TO != null
    },
    chartStyles () {
      return {
        height: '500px',
        position: 'relative'
      }
    },
    chartStylesSmall () {
      return {
        height: '350px',
        position: 'relative'
      }
    },
  },
  watch: {
    currentGroup(newVal) {
      this.$store.commit('analytics/salesAnalyticsCountry/CURRENT_GROUP', newVal)
      this.getChartDat()
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('analytics') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }

    this.dateRange.startDate = this.defaultDate
    this.dateRange.endDate = this.today

    this.currentGroup = this.CURRENT_GROUP
    this.$store.commit('analytics/salesAnalyticsCountry/FROM', this.dateToString(this.dateRange.startDate));
    this.$store.commit('analytics/salesAnalyticsCountry/TO', this.dateToString(this.dateRange.endDate));
    if (this.COUNTRY_DATA.length == 0) {
      this.GET_DATA({th: this});
    }
    if (this.HISTORY_DATA1.length == 0 && this.HISTORY_DATA2.length == 0 && this.HISTORY_DATA3.length == 0) {
      this.getChartDat()
    }
  },
  created() {
    this.perPage = this.initPageSize()
  }
}
</script>

<style scoped>
.search-box {
  width: 375px;
  float: left
}
.total-search-box {
  width: 525px;
}
.query-link {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
}
.query-link:hover {
  text-decoration: underline;
}
.chart-col {
  position: fixed;
  width: 500px;
  margin: auto;
}
.chart-box {
  width: 800px;
  display: block;
}
.chart-box-small {
  width: 800px;
  display: block;
  padding-left: 1px;
}
</style>

<style>

</style>